import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { Star, Quote } from "lucide-react";

export const TestimonialsSection = () => {
  const testimonials = [
    {
      name: "Sarah Mitchell",
      role: "HR Director, TechCorp",
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?crop=entropy&cs=srgb&fm=jpg&q=85&w=150",
      content: "Kamaliicious has been our go-to caterer for all corporate events. Their consistency and attention to detail is remarkable. Our team always looks forward to lunch days!",
      rating: 5
    },
    {
      name: "Raj Patel",
      role: "Father of the Bride",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=srgb&fm=jpg&q=85&w=150",
      content: "Our daughter's wedding was perfect thanks to Kamaliicious. The food received so many compliments, and they handled 300+ guests flawlessly. Truly professional yet personal service.",
      rating: 5
    },
    {
      name: "Priya Sharma",
      role: "Event Planner",
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?crop=entropy&cs=srgb&fm=jpg&q=85&w=150",
      content: "As an event planner, I've worked with many caterers. Kamaliicious stands out for their reliability and the genuine care they put into every dish. My clients are always impressed.",
      rating: 5
    },
    {
      name: "Michael Chen",
      role: "CEO, StartupHub",
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?crop=entropy&cs=srgb&fm=jpg&q=85&w=150",
      content: "We've been using Kamaliicious for our daily office lunches and team events for over 2 years. The food quality is consistently excellent, and their vegetarian options are actually delicious!",
      rating: 5
    },
    {
      name: "Anita Desai",
      role: "Community Leader",
      image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?crop=entropy&cs=srgb&fm=jpg&q=85&w=150",
      content: "For our Diwali celebration with 500+ attendees, Kamaliicious delivered beyond expectations. The traditional flavors reminded everyone of home. We've already booked them for next year!",
      rating: 5
    }
  ];

  return (
    <section
      id="testimonials"
      className="py-20 md:py-32 px-6 md:px-12 lg:px-24 bg-white"
      data-testid="testimonials-section"
    >
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16 space-y-4">
          <p className="text-sm tracking-widest uppercase font-semibold text-orange-700">
            What People Say
          </p>
          <h2 className="font-heading text-4xl md:text-5xl font-semibold tracking-tight text-gray-800">
            Trusted by Hundreds of Happy Clients
          </h2>
        </div>

        {/* Carousel */}
        <Carousel
          opts={{
            align: "start",
            loop: true,
          }}
          className="w-full"
        >
          <CarouselContent className="-ml-4">
            {testimonials.map((testimonial, index) => (
              <CarouselItem key={index} className="pl-4 md:basis-1/2 lg:basis-1/3">
                <div className="bg-stone-50 rounded-2xl p-6 md:p-8 h-full border border-stone-100 hover:shadow-md transition-shadow duration-300">
                  {/* Quote Icon */}
                  <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center mb-6">
                    <Quote className="w-5 h-5 text-orange-700" />
                  </div>

                  {/* Rating */}
                  <div className="flex gap-1 mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} className="w-5 h-5 fill-orange-400 text-orange-400" />
                    ))}
                  </div>

                  {/* Content */}
                  <p className="text-gray-700 leading-relaxed mb-6">
                    "{testimonial.content}"
                  </p>

                  {/* Author */}
                  <div className="flex items-center gap-4 pt-4 border-t border-stone-200">
                    <img
                      src={testimonial.image}
                      alt={testimonial.name}
                      className="w-12 h-12 rounded-full object-cover"
                    />
                    <div>
                      <p className="font-semibold text-gray-800">{testimonial.name}</p>
                      <p className="text-sm text-gray-600">{testimonial.role}</p>
                    </div>
                  </div>
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          <div className="flex justify-center gap-4 mt-8">
            <CarouselPrevious className="static translate-y-0 bg-white border-stone-200 hover:bg-orange-50 hover:border-orange-200" data-testid="testimonials-prev" />
            <CarouselNext className="static translate-y-0 bg-white border-stone-200 hover:bg-orange-50 hover:border-orange-200" data-testid="testimonials-next" />
          </div>
        </Carousel>
      </div>
    </section>
  );
};

export default TestimonialsSection;
